import { Translation } from '@ps/web-shared-components';
import React from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import { FormMethod } from '@swf/core/enums';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type {
  DepositContext,
  DepositPayload,
  DepositResult
} from '../../../../../../types/Cashier';
import { CardType } from '../../../../../../types/cardType';
import FirstLoader from '../../../../../FirstLoader/FirstLoader';
import useRedirectContext from '../../useRedirectContext';
import PayconiqRedirect from '../PayconiqRedirect/PayconiqRedirect';
import RedirectForm from '../RedirectForm/RedirectForm';

import { TXTWCL_WeXre_working_on_this } from './Redirect.messages.json';
import { loadingMessageWrapper } from './Redirect.scss';
import useOpenBanking from './hooks/useOpenBanking';

type Props = DepositResult &
  DepositContext & { cmsHeaderAndGridLayout: boolean } & { handleStatusChange?: () => void };

const Redirect: React.FC<Props> = ({
  redirectUrl,
  url,
  deposit = {} as DepositPayload,
  plaidLinkToken,
  qrCodeData = '',
  handleStatusChange
}) => {
  const redirectContext = useRedirectContext();
  const {
    data: { paySystemDetails }
  } = useWizardContext();

  const context = {
    ...redirectContext,
    plaidLinkToken,
    subSystemName: paySystemDetails?.allowedSubsystems?.find(
      (subSystem) => subSystem.productId === deposit.productId
    )?.description
  };

  const { openLink } = useOpenBanking(context);

  if (plaidLinkToken && deposit.type === CardType.OpenBanking) {
    openLink();
    return (
      <div className={loadingMessageWrapper}>
        <Translation {...TXTWCL_WeXre_working_on_this} tagName="p" />
        <LoadingIndicator loading />
      </div>
    );
  }
  if (deposit.type === CardType.Payconiq && handleStatusChange) {
    return <PayconiqRedirect qrCodeData={qrCodeData} handleStatusChange={handleStatusChange} />;
  }

  return (
    <>
      <FirstLoader />
      <RedirectForm context={context} {...(redirectUrl || { url, method: FormMethod.Get })} />
    </>
  );
};

export default Redirect;
